import styled from "styled-components";

export const ColdStartContainer = styled.div`
  background-color: rgb(3, 21, 31);
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  position: relative;
  min-width: 290px;
  height: 100%;
`;
export const MainContainer = styled.div`
  flex-grow: 1;
  height: 60%;
  box-sizing: border-box;
  padding: 0 50px;
  padding-left: 10px;
`;
